import { models } from "@/constants/llm";
import { z } from "zod";

export const chatConversationSchema = z.object({
  models: z.string().min(1),
  temperature: z.number().optional().nullable(),
  maxTokens: z.number().optional().nullable(),
  systemPrompt: z.string().optional(),
});

export type ChatConversationSchema = z.infer<typeof chatConversationSchema>;